export default "__VITE_ASSET__Bsg8c74b__"